// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GreetingCardBanner__container-fbcc01 {
  border-bottom: 1px solid var(--base-20);
  background: var(--base-15);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.GreetingCardBanner__app-info-d80292 {
  display: flex;
  align-items: center;
}

.GreetingCardBanner__logo-f8ab72 {
  width: 48px;
  height: 48px;
  vertical-align: middle;
}

.GreetingCardBanner__descriptions-fb4722 {
  margin-inline-start: 12px;
  color: var(--base-110);
}

.GreetingCardBanner__description-c1fc62 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: 0.25px;
}

.GreetingCardBanner__app-title-ccb5a3 {
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.1px;
}`, "",{"version":3,"sources":["webpack://./src/GreetingCard/GreetingCardBanner/GreetingCardBanner.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  border-bottom: 1px solid var(--base-20);\n  background: var(--base-15);\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.app-info {\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  width: 48px;\n  height: 48px;\n  vertical-align: middle;\n}\n\n.descriptions {\n  margin-inline-start: 12px;\n  color: var(--base-110);\n}\n\n.description {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: 0.25px;\n}\n\n.app-title {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0.1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GreetingCardBanner__container-fbcc01`,
	"app-info": `GreetingCardBanner__app-info-d80292`,
	"appInfo": `GreetingCardBanner__app-info-d80292`,
	"logo": `GreetingCardBanner__logo-f8ab72`,
	"descriptions": `GreetingCardBanner__descriptions-fb4722`,
	"description": `GreetingCardBanner__description-c1fc62`,
	"app-title": `GreetingCardBanner__app-title-ccb5a3`,
	"appTitle": `GreetingCardBanner__app-title-ccb5a3`
};
module.exports = ___CSS_LOADER_EXPORT___;
